import { render, staticRenderFns } from "./DateIOSPicker.vue?vue&type=template&id=643e0f3a&scoped=true"
import script from "./DateIOSPicker.vue?vue&type=script&lang=js"
export * from "./DateIOSPicker.vue?vue&type=script&lang=js"
import style0 from "./DateIOSPicker.vue?vue&type=style&index=0&id=643e0f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e0f3a",
  null
  
)

export default component.exports